var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "addQuestion"
    },
    [
      _vm.course && _vm.resourcesFrom == 1
        ? _c("div", { staticClass: "addQuestion_head" }, [
            _vm.showUpload
              ? _c("span", { staticStyle: { "padding-right": "20px" } }, [
                  _c(
                    "span",
                    {
                      staticClass: "zl_button zl_blueButton",
                      on: { click: _vm.createQuestionBtn }
                    },
                    [_vm._v("创建试题")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "zl_button zl_blueButton",
                      on: { click: _vm.addQues }
                    },
                    [_vm._v("添加试题")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.checkout
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "400",
                      "line-height": "28px",
                      "margin-right": "20px"
                    }
                  },
                  [
                    _vm._v(
                      "\n        已选择" +
                        _vm._s(
                          _vm.isShort
                            ? _vm.selectResourse.length
                            : _vm.checkList.length
                        ) +
                        "道实操题\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start"
                }
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "147px", "margin-right": "8px" },
                    attrs: {
                      placeholder: "全部分类",
                      clearable: "",
                      size: "mini"
                    },
                    on: {
                      clear: _vm.initPageTotal,
                      change: _vm.postGetQuestionByCourseId
                    },
                    model: {
                      value: _vm.categoryId,
                      callback: function($$v) {
                        _vm.categoryId = $$v
                      },
                      expression: "categoryId"
                    }
                  },
                  _vm._l(_vm.resourceDatas, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.categoryName, value: item.id }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.courseModel != 1
                  ? _c("el-cascader", {
                      ref: "cascader",
                      staticStyle: { width: "200px", "margin-right": "8px" },
                      attrs: {
                        size: "mini",
                        placeholder: "资源库分类",
                        options: _vm.cascaderOptions,
                        props: {
                          checkStrictly: true,
                          label: "name",
                          value: "id"
                        },
                        filterable: "",
                        clearable: "",
                        "show-all-levels": ""
                      },
                      on: { change: _vm.postGetQuestionByCourseId },
                      model: {
                        value: _vm.materialsId,
                        callback: function($$v) {
                          _vm.materialsId = $$v
                        },
                        expression: "materialsId"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "190px" },
                  attrs: {
                    clearable: "",
                    size: "mini",
                    placeholder: "请输入试题名称",
                    "suffix-icon": "el-icon-search"
                  },
                  on: { clear: _vm.initPageTotal },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.postGetQuestionByCourseId.apply(
                        null,
                        arguments
                      )
                    }
                  },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            )
          ])
        : _c(
            "div",
            { staticClass: "addQuestion_head" },
            [
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: {
                    size: "mini",
                    placeholder: "请选择难度",
                    clearable: ""
                  },
                  on: { change: _vm.getQuestionList },
                  model: {
                    value: _vm.conditionList.difficulty,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "difficulty", $$v)
                    },
                    expression: "conditionList.difficulty"
                  }
                },
                _vm._l(_vm.conditionList.difficultyList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: {
                    size: "mini",
                    placeholder: "请选择公司",
                    clearable: ""
                  },
                  on: { change: _vm.getQuestionList },
                  model: {
                    value: _vm.conditionList.company,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "company", $$v)
                    },
                    expression: "conditionList.company"
                  }
                },
                _vm._l(_vm.conditionList.companyList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "search_item",
                  attrs: {
                    size: "mini",
                    placeholder: "请选择标签",
                    clearable: ""
                  },
                  on: { change: _vm.getQuestionList },
                  model: {
                    value: _vm.conditionList.tag,
                    callback: function($$v) {
                      _vm.$set(_vm.conditionList, "tag", $$v)
                    },
                    expression: "conditionList.tag"
                  }
                },
                _vm._l(_vm.conditionList.tagList, function(item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.labelName, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: {
                  size: "mini",
                  placeholder: "请输入标题或题干",
                  clearable: ""
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getQuestionList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.conditionList.question,
                  callback: function($$v) {
                    _vm.$set(_vm.conditionList, "question", $$v)
                  },
                  expression: "conditionList.question"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: {
                    click: function($event) {
                      return _vm.getQuestionList()
                    }
                  }
                },
                [_vm._v("查询")]
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { flex: "1", position: "relative" } },
        [
          _c(
            "el-table",
            {
              ref: "cTable",
              attrs: {
                data: _vm.questionList,
                width: "100%",
                height: "calc(100% - 80px)",
                "cell-style": { textAlign: "left" },
                "header-cell-style": { textAlign: "left" }
              },
              on: {
                "row-click": _vm.rowClick,
                "selection-change": _vm.selectChange,
                select: _vm.selectExit,
                "select-all": _vm.selectExit
              }
            },
            [
              _vm.checkout
                ? _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  })
                : _c("el-table-column", {
                    attrs: { label: "", width: "55" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: scope.row.id },
                                model: {
                                  value: _vm.currentValue,
                                  callback: function($$v) {
                                    _vm.currentValue = $$v
                                  },
                                  expression: "currentValue"
                                }
                              },
                              [_vm._v(" ")]
                            )
                          ]
                        }
                      }
                    ])
                  }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "taskName", label: "标题" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.taskName && scope.row.taskName != ""
                          ? [_vm._v(_vm._s(scope.row.taskName))]
                          : [
                              scope.row.questionContent &&
                              _vm.$delHtmlTag
                                .delHtmlTag(scope.row.questionContent)
                                .substring(0, 100).length >= 100
                                ? [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.questionContent
                                            ? _vm.$delHtmlTag
                                                .delHtmlTag(
                                                  scope.row.questionContent
                                                )
                                                .substring(0, 100) + "..."
                                            : ""
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.questionContent
                                            ? _vm.$delHtmlTag
                                                .delHtmlTag(
                                                  scope.row.questionContent
                                                )
                                                .substring(0, 100)
                                            : ""
                                        ) +
                                        "\n              "
                                    )
                                  ]
                            ]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.environment
                ? _c("el-table-column", {
                    attrs: { prop: "questionAnswer", label: "环境" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.questionAnswer &&
                              scope.row.questionAnswer != ""
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("handleAnswer")(
                                          scope.row.questionAnswer
                                        )
                                      )
                                    )
                                  ]
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1602948037
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "questionTypeName", label: "题型", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "difficulty", label: "难度", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.difficulty == 1
                              ? "简单"
                              : scope.row.difficulty == 2
                              ? "中等"
                              : scope.row.difficulty == 3
                              ? "困难"
                              : ""
                          ) + "\n          "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "score", label: "建议分数", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#1890FF" },
                            attrs: { size: "mini", type: "text" },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showRow(scope.row, scope.$index)
                              }
                            }
                          },
                          [_vm._v("\n              预览\n            ")]
                        ),
                        _vm._v(" "),
                        scope.row.internalTypeId == 9 && _vm.courseModel != 1
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "#1890FF" },
                                attrs: { size: "mini", type: "text" },
                                nativeOn: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.handleGoResource(
                                      scope.row,
                                      scope.$index
                                    )
                                  }
                                }
                              },
                              [_vm._v("\n              编辑\n            ")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "empty_material",
                  attrs: { slot: "empty" },
                  slot: "empty"
                },
                [_c("p", [_vm._v("暂无试题")])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination_class" },
            [
              _c("Pagination", {
                attrs: {
                  currentpage: _vm.pageTotal.currentPage,
                  limit: _vm.pageTotal.pageSize,
                  total: _vm.pageTotal.total,
                  layout: "sizes, prev, pager, next, jumper",
                  small: true
                },
                on: {
                  handleCurrentChange: _vm.handleCurrentChange,
                  handleSizeChange: _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("n-dialog", {
        attrs: {
          title: "提示",
          dialogVisible: _vm.addTestPaperShow,
          width: "400px",
          dialogType: _vm.dialogType,
          deleteNum: "1",
          deleteName: _vm.deleteName,
          isDedicated: _vm.isDedicated
        },
        on: { conformFunc: _vm.conformFunc, closeDialog: _vm.closeDialog }
      }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.createQuestionShow,
            direction: _vm.direction,
            size: "80%",
            "with-header": false,
            "close-on-press-escape": false,
            "before-close": _vm.closeCreateQuestion
          },
          on: {
            "update:visible": function($event) {
              _vm.createQuestionShow = $event
            }
          }
        },
        [
          _c("createQuestion", {
            ref: "createQuestion",
            attrs: {
              courseId: _vm.courseId,
              isShowResourceClassify: _vm.isShowResourceClassify
            },
            on: {
              closeCreateQuestion: _vm.closeCreateQuestion,
              saveQuestion: _vm.saveQuestion
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("n-dialog", {
        attrs: {
          isField: _vm.isField,
          subjectId: _vm.subjectId,
          title: _vm.dialogTitle,
          dialogVisible: _vm.addQuestionShow,
          width: _vm.dialogWidth,
          courseId: _vm.courseId,
          questionId: _vm.questionId,
          dialogType: _vm.dialogType
        },
        on: { closeDialog: _vm.closeDialog1 }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25cd656b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25cd656b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/addQuestion.vue
// module id = null
// module chunks = 